<div class="modal-body" [hidden]="minimise">
  <form class="form-horizontal" novalidate>
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    <div class="systemSummary">
      <div class="leftText nowrap">
        <strong>Local Chart: </strong> {{CHART_DISPLAY}} <br>
        <strong>Local Account: </strong> {{LOCAL_ACCT_DISPLAY}} <br>
        <strong>System Account: </strong> {{SYSTEM_ACC_DISPLAY}}
      </div>
    </div>
    <div class="mapping-panel">
      <div class="mapping-header">
        IRS Form Mapping
        <button type="button" class="btn btn-success btn-xs mapping-btn" (click)="toggleLookup()">Form Mapping</button>
        <i class="glyphicon"
           [ngClass]="{'glyphicon-chevron-down': lookUpMapping, 'glyphicon-chevron-up': !lookUpMapping}"
           (click)="toggleLookup()"></i>
      </div>
      @if (lookUpMapping) {
<div class="mapping-content">
        <div class="table-responsive">
          <table class="table table-hover table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th>IRS Form</th>
                <th>Schedule</th>
                <th>Line No.</th>
                <th>Line Description.</th>
                <th>Column</th>
              </tr>
            </thead>
            <tbody>
              @for (t of sortedSystemAndLocalAccountData; track trackByIndex($index)) {
<tr>
                <td>{{ t.FORM }}</td>
                <td>{{ t.SCHEDULE }}</td>
                <td>{{ t.LINE }}</td>
                <td>{{ t.LINE_DESC }}</td>
                <td>{{ t.COL }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
}
    </div>

    <div class="row amount-row">
      <div class="col-md-3">
        <label>Py Amount:</label>
        <div class="input-group"><span class="input-group-addon">{{curr}}</span><input name="pyAmount" class="form-control" [ngModel]="pyAmount" readonly type="text"></div>
      </div>
      <div class="col-md-3">
        <label>Cy Amount:</label>
        <div class="input-group"><span class="input-group-addon">{{curr}}</span><input name="cyAmount" class="form-control" [ngModel]="cyAmount" readonly type="text"></div>
      </div>
      <div class="col-md-3">
        <label>Repointing Amount:</label>
        <div class="input-group"><span class="input-group-addon">{{curr}}</span><input readonly type="text" name="repointingAmount" class="form-control" [ngModel]="repointingAmount"></div>
      </div>
      <div class="col-md-3">
        <label>Remaining Cy Amount:</label>
        <div class="input-group"><span class="input-group-addon">{{curr}}</span><input name="remainingCyAmount" class="form-control" [ngModel]="remainingCyAmount" readonly type="text"></div>
      </div>
      <div class="col-md-4 col-md-offset-4 repoint-error-wrap">
        @if (showRepointingError) {
<div class="form-error-container">
          Repointing amount cannot be greater than current year amount
        </div>
}
      </div>
    </div>

    <div class="row desc-row">
      <div class="col-md-6">
        <label>Repointing Desc:</label>
        <input type="text" class="form-control" [ngClass]="{'error-input': showRepointingDescError}"
               placeholder="Enter Repointing Description" [(ngModel)]="Repoint.ADJUSTMENT_DESC"
               (ngModelChange)="adjDescChanged()" name="adjustmentDesc">
      </div>
      <div class="col-md-3 desc-error">
        @if (showRepointingDescError) {
<div class="form-error-container">Please add repointing description</div>
}
      </div>
    </div>

    <hr class="separator-line">

    @if (!loadLookUpData) {
<div class="gt-filter-loading">
      <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
    </div>
}

    <div class="repoint-rows">
      @for (repoint of repointList; track trackByIndex(i); let i = $index) {
<div>
        <div class="row repoint-row">
          <div class="col-sm-1 icon-col">
            @if (repoint.DELETE_BTN) {
<i
               class="fa fa-minus-circle color-red action-icon"
               (click)="removeRepointAmount(i, repoint.GROUP_KEY)">
            </i>
}
          </div>

          <div class="col-md-5">
            <label>System Account</label>
            <div class="row">
              <div class="col-md-9">
                <select class="form-control input-sm"
                        [(ngModel)]="repoint.SYSC_ACCT"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="repoint.DISABLED"
                        (ngModelChange)="changeSystemacct()">
                  <option value="" disabled>Select...</option>
                  @for (option of getSystemAccountOptions(); track $index) {
<option [ngValue]="option">{{option}}</option>
}
                </select>
              </div>
              <div class="col-md-3 lookup-btn-wrap">
                <button type="button" class="btn btn-success btn-sm lookup-btn">Look Up</button>
              </div>
            </div>
            @if (repoint.sysacctflag) {
<div class="form-error-container">Please Select a System Account</div>
}
            @if (repoint.sameacctFlag && !repoint.sysacctflag) {
<div class="form-error-container">Please Select a Different System Account</div>
}
          </div>

          <div class="col-md-3">
            <label>Amount:</label>
            <div class="input-group">
              <span class="input-group-addon">{{curr}}</span>
              <input type="text"
                     class="form-control"
                     [ngClass]="{'error-input': repoint.acctzeroflag || repoint.AMMOUNT === 0}"
                     name="amount_{{i}}"
                     [(ngModel)]="repoint.AMMOUNT"
                     [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="updateAmt(repoint.GROUP_KEY, repoint.AMMOUNT)"
                     [disabled]="repoint.DISABLED">
              <span class="input-group-addon apply-wrap">
                <button type="button" class="apply-btn" (click)="applycyamt(i)">Apply</button>
              </span>
            </div>
            @if (repoint.acctzeroflag || repoint.AMMOUNT === 0) {
<div class="form-error-container">
              Amount cannot be zero
            </div>
}
          </div>

          <div class="col-md-3">
            <label>Trading Partner:</label>
            <div class="autocomplete-wrapper">
              <div class="input-group">
                <input type="text"
                       class="form-control input-sm"
                       placeholder="begin typing to select trading partner"
                       [value]="repoint.tpSearchText || repoint.TP_ENTITY || ''"
                       (input)="searchTradingPartners($event, i)">
                <span class="input-group-addon">
                  @if (loadingTpSearch && activeTPSearchIndex === i) {
<i class="fa fa-spinner fa-pulse"></i>
}
                  @if (!loadingTpSearch || activeTPSearchIndex !== i) {
<i class="fa fa-search"></i>
}
                </span>
              </div>
              @if (tpSearchResults.length > 0 && activeTPSearchIndex === i) {
<div class="autocomplete-dropdown">
                @for (tp of tpSearchResults; track $index) {
<div class="autocomplete-item" (click)="selectTradingPartner(tp, i)">
                  {{tp.TP_ENTITY}}
                </div>
}
              </div>
}
            </div>
          </div>
        </div>
        <hr class="separator-line">
      </div>
}

      <div class="row">
        <div class="col-sm-1 icon-col">
          <i class="fa fa-plus-circle color-green action-icon" (click)="addRepoint()"></i>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>

